/// <reference path="../_references.ts"/>

module App.WorkOrderTemplate {
	export class WorkOrderTemplateService {
		constructor(
			private $http: ng.IHttpService,
			public Constants: IConstants
		) {

		}

		fetchAll(serviceRequestId: number, query: string, favorites: true | null, size: number | null, page: number | null): ng.IHttpPromise<Template[]> {
			return this.$http.get(`${this.Constants.apiUrl}template`, {
				params: {
					service_request_id: serviceRequestId,
					query: query,
					favorites: favorites,
					size: size,
					page: page,
				}
			});
		}

		delete(id: number, params?: any): ng.IHttpPromise<Template> {
			return this.$http.delete(`${this.Constants.apiUrl}template/${id}`, {
				params: params || {},
			});
		}

		addFavorite(templateId: number): ng.IHttpPromise<void> {
			return this.$http.post(`${this.Constants.apiUrl}template/${templateId}/favorite`, {});
		}

		removeFavorite(templateId: number): ng.IHttpPromise<void> {
			return this.$http.post(`${this.Constants.apiUrl}template/${templateId}/unfavorite`, {});
		}

		load(serviceRequestId: number, templateIds: string): ng.IHttpPromise<Template> {
			return this.$http.post(`${this.Constants.apiUrl}servicerequest/${serviceRequestId}/loadtemplate/${templateIds}`, {});
		}

		create(serviceRequestId: number, template: App.WorkOrder.Template): ng.IHttpPromise<Template> {
			return this.$http.post(`${this.Constants.apiUrl}servicerequest/${serviceRequestId}/template`, template);
		}

		public static Factory() {
			let instance = ($http: ng.IHttpService, Constants: IConstants) => {
				return new WorkOrderTemplateService($http, Constants);
			};

			instance.$inject = ['$http', 'Constants'];

			return instance;
		}
	}
}